var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoEcoeNoChar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00837b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-ecoe-no-char") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.82,73.31a18.31,18.31,0,1,1,18-22.74L110,41.69A55.69,55.69,0,0,0,55.82,0c-1.15,0-2.29,0-3.43.11V33.63L41.87,1.73a57.26,57.26,0,0,0-6.54,2.09l10.52,31.9-20-27.13a56.24,56.24,0,0,0-5.56,4l20,27.12L12.77,20a55.73,55.73,0,0,0-4,5.48L36.26,45.18,3.88,34.81a52.74,52.74,0,0,0-2.12,6.44L34.13,51.62H.11C0,52.74,0,53.86,0,55s0,2.26.11,3.38h34L1.76,68.75a52.74,52.74,0,0,0,2.12,6.44L36.26,64.82,8.72,84.53a55.73,55.73,0,0,0,4,5.48L40.3,70.3l-20,27.12a56.24,56.24,0,0,0,5.56,4l20-27.13-10.53,31.9a57.26,57.26,0,0,0,6.54,2.09l10.52-31.9v33.52c1.14.07,2.28.11,3.43.11A55.69,55.69,0,0,0,110,68.31L73.86,59.43A18.54,18.54,0,0,1,55.82,73.31Z",
    transform: "translate(0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEcoeNoChar);
export default __webpack_public_path__ + "static/media/logo-ecoe-no-char.9374300fb569582f131b16129e59cbb9.svg";
export { ForwardRef as ReactComponent };